if (!customElements.get("td-expanding-features")) {
  class TdExpandingFeatures extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const sectionWrapper = this.querySelector('.td-ef__top-wrapper');
      
      if (!sectionWrapper) return;

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            sectionWrapper.classList.add('td-ef__section-wrapper--animate');
            observer.disconnect();
          }
        });
      }, { threshold: 0.1 });
      observer.observe(sectionWrapper);
    }
  }

  customElements.define("td-expanding-features", TdExpandingFeatures);
}
